import React from 'react'
import PropTypes from 'prop-types'
import styles from './Badge.module.scss'

export const BADGE_TONES = ['approved', 'review', 'watch', 'declined', 'closed']

const cx = (...p) => p.filter(Boolean).join(' ')

export const Badge = ({ tone = 'closed', dot = true, children, className, ...rest }) => (
  <span className={cx(styles.badge, styles[tone], className)} {...rest}>
    {dot && <span className={styles.dot} aria-hidden="true" />}
    {children}
  </span>
)

Badge.propTypes = {
  tone: PropTypes.oneOf(BADGE_TONES),

  dot: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const Tag = ({ children, onRemove, removeLabel, className, ...rest }) => (
  <span className={cx(styles.tag, className)} {...rest}>
    {children}
    {onRemove && (
      <button
        type="button"
        className={styles.remove}
        onClick={onRemove}
        aria-label={removeLabel || `Remove ${typeof children === 'string' ? children : 'filter'}`}
      >
        &times;
      </button>
    )}
  </span>
)

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,

  removeLabel: PropTypes.string,
  className: PropTypes.string,
}

export default Badge
